import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import React from 'react'
import { sportCreationStore } from 'state/listing/sportListing'
import LeagueSportForm from './ModalContent/LeagueSportForm'

const LeagueSportModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()

  const { sportData, setSportData, addSportModal, setAddSportModal } =
    sportCreationStore(store => ({
      sportData: store.sportData,
      setSportData: store.setSportData,
      addSportModal: store.addSportModal,
      setAddSportModal: store.setAddSportModal,
    }))

  const handleClose = () => {
    setSportData(undefined)
    setAddSportModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={addSportModal}
        closeModal={handleClose}
        title={sportData ? 'Edit League Sport' : 'Add new League Sport'}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText={sportData ? 'Update' : 'Create'}
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <LeagueSportForm form={form} />
      </CustomModal>
    </>
  )
}

export default LeagueSportModal
